import "@/style/index.scss";
import "@/utils/nav";
import "@/utils/tab.js"
import "@/utils/banner.js";
import "@/utils/information.js"
import "@/utils/member.js"
import "@/utils/website.js"
import accor from "@/utils/accordion";
import "@/style/accordion.scss";
import "@/utils/ft-carousel.min";
import "default-passive-events";

const sideItems = document.querySelectorAll(".n_side-item");
const navigationSide = $("#navigationSide");
// navigationSide.hide();

// new slidePage({
//   slideContainer: "#slide-container",
//   page: 1,
//   refresh: true,
//   // Events
//   before: function (origin, direction, target) {
//     const nowIdx = target - 1;
//     nowIdx === 0 ? navigationSide.hide() : navigationSide.show();
//     sideItems.forEach((item, idx) => {
//       item.className = "n_side-item";
//       if (nowIdx !== 0) item.className += " side-item__black";
//       if (idx === nowIdx) item.className += " side-item__active";
//     });
//   },
// });

accor($("#Accor4"), "50%", 500);

$("#ftCarousel").FtCarousel({
  index: 0,
  auto: true,
  time: 4000,
  indicators: false,
  buttons: true,
});

// $("#ftCarousel_news").FtCarousel({
//   index: 0,
//   auto: true,
//   time: 4000,
//   indicators: false,
//   buttons: true,
// });

const nav = $("#information").text()

// 会员列表
// $.get(develop + "/system/exc/official/menber/memberList?current=1&size=60", function (data) {
//   const list = data.data.records;
//   var contents = '';
//   $.each(list, function (i) {
//     if (list[i].logo !== null) {
//       const imgList = "<img src=" + list[i].logo + ">" + "</img>"
//       contents +=
//         '<li class=' + 'member-list__item ' + '>' +
//         '<a href=' + list[i].website + '>' +
//         imgList +
//         // "<img src=" + list[i].logo + ">" + "</img>" +
//         '</a>'
//       '</li>';
//       $(".member-list").html(contents);
//     }

//   });
// });

// 会员列表滚动
// window.onload = function () {
//   var odiv = document.getElementById('member-box');
//   var oul = odiv.getElementsByTagName('ul')[0];
//   var ali = oul.getElementsByTagName('li');
//   setTimeout(() => {
//     var spa = -2;
//     oul.innerHTML = oul.innerHTML + oul.innerHTML;
//     oul.style.width = ali[0].offsetWidth * ali.length + 'px';
//     function move() {
//       if (oul.offsetLeft < -oul.offsetWidth / 2) {
//         oul.style.left = '0';
//       }
//       if (oul.offsetLeft > 0) {
//         oul.style.left = -oul.offsetWidth / 2 + 'px'
//       }
//       oul.style.left = oul.offsetLeft + spa + 'px';
//     }
//     var timer = setInterval(move, 20)

//     odiv.onmouseenter = function () { clearInterval(timer); }
//     odiv.onmouseleave = function () { timer = setInterval(move, 20) };
//   }, 2000)
// }
